import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizePreClaimsInitialValues } from './normalize';

export const fetchPreClaimsInitialValues = createProvider(api.fetchPreClaimsInitialValues)
  .andThen((res) => normalizePreClaimsInitialValues(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
